module.exports = __webpack_public_path__ + "static/media/ecommerce-3562191_1920.3a83f907.jpg";